import React from "react";
import { Translation } from "../../Translation";
import { appConfig } from "../../config";
import { inject, observer } from "mobx-react";

@inject("AppStore")
@observer
class FooterButtons extends React.Component {
  store = this.props.AppStore;

  // Previous button rendering
  renderPrevButton = () => {
    const { page } = this.store;

    if (page.stepIndex === 0) {
      return (
        <div className="modelSelector__cleanbutton" style={{ marginRight: 15 }}>
          <a href={`/`}>
            <Translation lang={this.store.page.lang} t="prev" />
          </a>
        </div>
      );
    }

    if (page.stepIndex > 0) {
      if (
        page.stepIndex === page.paymentStep ||
        page.stepIndex === page.brokerStep ||
        page.stepIndex === page.factoryStep
      ) {
        return (
          <div
            className="modelSelector__cleanbutton"
            style={{ marginRight: 15 }}
          >
            <a
              onClick={(e) => {
                e.preventDefault();
                this.store.onStepSelected({}, page.summaryStep);
              }}
            >
              <Translation lang={this.store.page.lang} t="prev" />
            </a>
          </div>
        );
      } else {
        return (
          <div
            className="modelSelector__cleanbutton"
            style={{ marginRight: 15 }}
          >
            <a onClick={this.store.prevStep}>
              <Translation lang={this.store.page.lang} t="prev" />
            </a>
          </div>
        );
      }
    }

    return null;
  };

  // Render buttons specific to summary step
  renderSummaryButtons = () => {
    const { page, user, broker } = this.store;

    if (
      page.stepIndex === page.summaryStep &&
      user &&
      user.user.factory_order
    ) {
      return (
        <div className="modelSelector__cleanbutton" style={{ marginRight: 15 }}>
          <a onClick={() => this.store.onStepSelected({}, page.factoryStep)}>
            FACTORY ORDER
          </a>
        </div>
      );
    }

    if (page.stepIndex === page.summaryStep) {
      if (broker) {
        return (
          <React.Fragment>
            <div className="modelSelector__cleanbutton">
              <a
                onClick={() =>
                  this.store.onBrokerageStepSelected(
                    {},
                    this.store.page.brokerStep
                  )
                }
              >
                SALES AGREEMENT
              </a>
            </div>
            <div
              className="modelSelector__cleanbutton"
              style={{ marginLeft: 15 }}
            >
              <a
                onClick={() =>
                  this.store.onStepSelected({}, this.store.page.pdfStep)
                }
              >
                <Translation t="SEND PDF" lang={this.store.page.lang} />
              </a>
            </div>
          </React.Fragment>
        );
      } else {
        return (
          <React.Fragment>
            <div className="modelSelector__cleanbutton">
              <a
                onClick={() =>
                  this.store.onStepSelected({}, this.store.page.pdfStep)
                }
              >
                <Translation t="SEND PDF" lang={this.store.page.lang} />
              </a>
            </div>
            {appConfig.locale.has_payment && (
              <div
                className="modelSelector__cleanbutton"
                style={{ marginLeft: 15 }}
              >
                <a
                  onClick={() =>
                    this.store.onStepSelected({}, this.store.page.paymentStep)
                  }
                >
                  RESERVE NOW
                </a>
              </div>
            )}
          </React.Fragment>
        );
      }
    }

    return null;
  };

  // Render PDF step buttons
  renderPdfButtons = () => {
    const { page, user } = this.store;

    if (page.stepIndex === page.pdfStep) {
      return (
        <React.Fragment>
          <div
            className="modelSelector__cleanbutton"
            style={{ marginRight: 15 }}
          >
            <a
              onClick={(e) => {
                var form = document.getElementById("pdf_form");
                if (form.reportValidity()) {
                  this.store.onPdfSubmit(e);
                }
              }}
            >
              <Translation t="SEND PDF" lang={this.store.page.lang} />
            </a>
          </div>
          {user && (
            <div className="modelSelector__cleanbutton">
              <a
                onClick={(e) => {
                  this.store.onPdfDownload(e);
                }}
              >
                DOWNLOAD PDF
              </a>
            </div>
          )}
        </React.Fragment>
      );
    }

    return null;
  };

  // Render next button
  renderNextButton = () => {
    const { page, checkNext } = this.store;

    if (page.stepIndex < page.summaryStep) {
      if (checkNext) {
        if (this.store.page.nextEnabled) {
          return (
            <div className="modelSelector__cleanbutton">
              <a onClick={this.store.nextStep}>
                <Translation lang={this.store.page.lang} t="next" />
              </a>
            </div>
          );
        } else {
          return (
            <div className="modelSelector__cleanbutton disabled">
              <a>
                <Translation lang={this.store.page.lang} t="next" />
              </a>
            </div>
          );
        }
      } else {
        return (
          <div className="modelSelector__cleanbutton disabled">
            <a title="You must select at least one option">
              <Translation lang={this.store.page.lang} t="next" />
            </a>
          </div>
        );
      }
    }

    return null;
  };

  render() {
    return (
      <>
        {this.renderPrevButton()}
        {this.renderSummaryButtons()}
        {this.renderPdfButtons()}
        {this.renderNextButton()}
      </>
    );
  }
}

export default FooterButtons;
